import { FaLock, FaThumbsUp, FaUserShield } from "react-icons/fa";

const whyChooseUs = {
  sub: "Why Choose Us",
  heading: "Securing Homes, Ensuring Peace of Mind.",
  content:
    "At LockGuard, our mission is to secure homes and ensure peace of mind for our customers through reliable locksmith services.",
  points: [
    {
      id: 1,
      icon: <FaLock />, // Lock icon
      title: "Security Solutions",
      content:
        "We provide comprehensive security solutions tailored to meet the unique needs of each client, ensuring their properties are well-protected.",
    },
    {
      id: 2,
      icon: <FaThumbsUp />, // Thumbs-up icon
      title: "Customer Satisfaction",
      content:
        "Our priority is customer satisfaction. We strive to exceed expectations by delivering exceptional service and ensuring customer peace of mind.",
    },
    {
      id: 3,
      icon: <FaUserShield />, // User Shield icon
      title: "Trusted Professionals",
      content:
        "Our team consists of certified and background-checked locksmiths who uphold the highest standards of reliability and trust.",
    },
  ],
};

export default whyChooseUs;